import React, { Component, Fragment } from "react";
import { PlusCircle } from "react-feather";
import { Button, TableComponent } from "components";
import InputSelect from "components/atoms/InputSelect";
import InputDateTime from "components/InputDateTime";
import moment from "moment";
import Wilayah from "services/Wilayah";
import { PageMode, Source, UserLevel } from "utils/constant";
import UserVerification from "services/UserVerification";
import { isEmpty } from "utils/common";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";

const WilayahService = new Wilayah();
const UserVerService = new UserVerification();

const defaultTabState = {
  year: "",
  province_id: "",
  district_id: "",
  page: 1,
  limit: 10,
  searchValue: null,
  searchBy: null,
  data: [],
};

export default class Table extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tabStates: {
        1: { ...defaultTabState },
        2: { ...defaultTabState },
        3: { ...defaultTabState },
        4: { ...defaultTabState },
        5: { ...defaultTabState },
      },
      year_error: false,
      provincies: [],
      districts: [],
      loading: false,
      selectedTab: 1,
    };
  }

  componentDidMount = () => {
    this._isMounted = true;
    const { user, initialTab } = this.props;
    this.getProvincies();
    this.getDistricts();
    const provId = user.province_id?.split("|")[0];
    const distId = user.district_id?.split("|")[0];

    const targetTab = initialTab || 1;
    const tabDefaults = {
      1: { province_id: provId || "", district_id: distId || "" },
      2: { province_id: provId || "", district_id: "" },
      3: { province_id: "", district_id: "" },
      4: { province_id: "", district_id: "" },
      5: { province_id: provId || "", district_id: distId || "" },
    };
    const defs = tabDefaults[targetTab] || tabDefaults[1];

    this.setState({ selectedTab: targetTab }, () => {
      this.setTabState(
        { year: moment().format("YYYY"), ...defs },
        () => {
          this.getAllData();
        }
      );
    });
  };

  onRemove = (id) => {
    confirmAlert({
      title: "Anda yakin ingin menghapus data ini?",
      message: "Are you sure want to delete this data?",
      buttons: [
        {
          label: "Ya",
          onClick: async () => {
            await UserVerService.remove(id)
              .then((res) => {
                this.getAllData();
                toast.success("Data verifikasi user berhasil dihapus", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              })
              .catch((err) => {
                console.log(err);
              });
          },
        },
        {
          label: "Tidak",
        },
      ],
    });
  };

  getProvincies = async () => {
    await WilayahService.getAll(Source.PROVINCE, { page: 1, limit: 999 })
      .then((res) => {
        this.setState({
          provincies: res.province,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getDistricts = async (province_id) => {
    await WilayahService.getAll(Source.DISTRICT, {
      page: 1,
      limit: 999,
      searchBy: "province_id",
      searchValue: province_id,
    })
      .then((res) => {
        this.setState({
          districts: res.district,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getTabState = () => {
    return this.state.tabStates[this.state.selectedTab];
  };

  setTabState = (updates, callback) => {
    const { selectedTab, tabStates } = this.state;
    this.setState(
      {
        tabStates: {
          ...tabStates,
          [selectedTab]: { ...tabStates[selectedTab], ...updates },
        },
      },
      callback
    );
  };

  switchTab = (tabIdx, extraTabState, callback) => {
    this.setState({ selectedTab: tabIdx }, () => {
      if (extraTabState) {
        this.setTabState(extraTabState, callback);
      } else if (callback) {
        callback();
      }
    });
  };

  handleInputChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    this.setTabState({ [name]: value });
  };

  mapper = (e) => {
    const options = [];
    e.map((x) => {
      options.push({ value: `${x.id}`, label: x.name });
    });
    return options;
  };

  getLevelFromTab = () => {
    switch (this.state.selectedTab) {
      case 2:
        return "District";
      case 3:
        return "Province";
      case 4:
        return "BKK";
      case 5:
        return "Labkesmas";
      default:
        return "Fasyankes";
    }
  };

  onPageChange = (page) => {
    this.setTabState({ page }, () => {
      this.getAllData(this.getLevelFromTab());
    });
  };

  onSearch = (e) => {
    const val = e.target.value;
    if (val) {
      this.setTabState({ searchBy: "first_name", searchValue: `${val}` }, () => {
        this.getAllData(this.getLevelFromTab());
      });
    } else {
      this.setTabState({ searchBy: null, searchValue: null }, () => {
        this.getAllData(this.getLevelFromTab());
      });
    }
  };

  onFilter = (e) => {
    const { year } = this.getTabState();
    if (isEmpty(year) || year === "Invalid date") {
      this.setState({ year_error: true });
    } else {
      this.setState({ year_error: false }, () => {
        this.getAllData(this.getLevelFromTab());
      });
    }
  };

  getAllData = (lvl) => {
    const actualLvl = lvl || this.getLevelFromTab();
    this.setState({ loading: true }, async () => {
      const { page, limit, searchBy, searchValue, year, province_id, district_id } =
        this.getTabState();

      let srchBy = searchBy ? `,${searchBy}` : "";
      let srchVal = searchValue ? `,${searchValue}` : "";

      switch (actualLvl) {
        case "Fasyankes":
          srchBy += ",level,province_id";
          srchVal += `,${actualLvl},${province_id}`;
          if (district_id) {
            srchBy += ",district_id";
            srchVal += `,${district_id}`;
          }
          break;
        case "District":
          srchBy += ",level,province_id";
          srchVal += `,${actualLvl},${province_id}`;
          break;
        case "Province":
          srchBy += ",level";
          srchVal += `,${actualLvl}`;
          break;
        case "BKK":
          srchBy += ",level";
          srchVal += `,${actualLvl}`;
          break;
        case "Labkesmas":
          srchBy += ",level";
          srchVal += `,${actualLvl}`;
          if (province_id) {
            srchBy += ",province_id";
            srchVal += `,${province_id}`;
          }
          if (district_id) {
            srchBy += ",district_id";
            srchVal += `,${district_id}`;
          }
          break;
        default:
          break;
      }

      await UserVerService.getAll({
        page,
        limit,
        searchValue: `${year}${srchVal}`,
        searchBy: `year${srchBy}`,
      })
        .then((data) => {
          if (this._isMounted) {
            this.setTabState({ data });
            this.setState({ loading: false });
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({ loading: false });
        });
    });
  };

  render() {
    const { changeMode, onEdit, user } = this.props;
    const { provincies, districts, year_error, loading, selectedTab } = this.state;
    const tabState = this.getTabState();
    const { year, province_id, district_id, data } = tabState;

    // For Labkesmas tab, elevate user.level to top level for TableComponent levelLabels mapping
    const tableData =
      selectedTab === 5 && data?.user_verifications
        ? data.user_verifications.map((item) => ({
            ...item,
            level: item.user?.level,
          }))
        : data?.user_verifications;

    const headers =
      selectedTab === 5
        ? ["Nama Pengguna", "Username", "Level", "Tahun", "Mode"]
        : ["Nama Pengguna", "Username", "Tahun", "Mode"];
    const cols =
      selectedTab === 5
        ? ["user.first_name", "user.username", "level", "year", "mode"]
        : ["user.first_name", "user.username", "year", "mode"];

    return (
      <div>
        <div className="d-flex justify-content-start py-2">
          <div>
            <ul
              className="nav nav-pills nav-success"
              id="pills-tab"
              role="tablist"
            >
              {/* Tab Fasyankes */}
              <li className="nav-item submenu">
                <a
                  className={`nav-link ${
                    selectedTab === 1 ? "show active" : ""
                  }`}
                  id="pills-fasyankes-tab"
                  data-toggle="pill"
                  href="#pills-fasyankes"
                  role="tab"
                  aria-controls="pills-fasyankes"
                  aria-selected="true"
                  onClick={() => {
                    const provId = user.province_id?.split("|")[0];
                    const distId = user.district_id?.split("|")[0];
                    this.switchTab(
                      1,
                      {
                        year: moment().format("YYYY"),
                        province_id: province_id || provId || "",
                        district_id: district_id || distId || "",
                        page: 1,
                        limit: 10,
                        searchValue: null,
                        searchBy: null,
                        data: [],
                      },
                      () => this.getAllData("Fasyankes")
                    );
                  }}
                >
                  Fasyankes
                </a>
              </li>
              {/* Tab District */}
              {(user.level === UserLevel.Province ||
                user.level === UserLevel.National) && (
                <li className="nav-item submenu">
                  <a
                    className={`nav-link ${
                      selectedTab === 2 ? "show active" : ""
                    }`}
                    id="pills-kab-tab"
                    data-toggle="pill"
                    href="#pills-kab"
                    role="tab"
                    aria-controls="pills-kab"
                    aria-selected="false"
                    onClick={() => {
                      const provId = user.province_id?.split("|")[0];
                      this.switchTab(
                        2,
                        {
                          year: moment().format("YYYY"),
                          province_id: province_id || provId || "",
                          district_id: "",
                          page: 1,
                          limit: 10,
                          searchValue: null,
                          searchBy: null,
                          data: [],
                        },
                        () => this.getAllData("District")
                      );
                    }}
                  >
                    Kabupaten
                  </a>
                </li>
              )}
              {/* Tab Province */}
              {user.level === UserLevel.National && (
                <>
                  <li className="nav-item submenu">
                    <a
                      className={`nav-link ${
                        selectedTab === 3 ? "show active" : ""
                      }`}
                      id="pills-prov-tab"
                      data-toggle="pill"
                      href="#pills-prov"
                      role="tab"
                      aria-controls="pills-prov"
                      aria-selected="false"
                      onClick={() => {
                        this.switchTab(
                          3,
                          {
                            year: moment().format("YYYY"),
                            province_id: "",
                            district_id: "",
                            page: 1,
                            limit: 10,
                            searchValue: null,
                            searchBy: null,
                            data: [],
                          },
                          () => this.getAllData("Province")
                        );
                      }}
                    >
                      Provinsi
                    </a>
                  </li>
                  <li className="nav-item submenu">
                    <a
                      className={`nav-link ${
                        selectedTab === 4 ? "show active" : ""
                      }`}
                      id="pills-bkk-tab"
                      data-toggle="pill"
                      href="#pills-bkk"
                      role="tab"
                      aria-controls="pills-bkk"
                      aria-selected="false"
                      onClick={() => {
                        this.switchTab(
                          4,
                          {
                            year: moment().format("YYYY"),
                            province_id: "",
                            district_id: "",
                            page: 1,
                            limit: 10,
                            searchValue: null,
                            searchBy: null,
                            data: [],
                          },
                          () => this.getAllData("BKK")
                        );
                      }}
                    >
                      BKK
                    </a>
                  </li>
                </>
              )}
              {/* Tab Labkesmas */}
              {(user.level === UserLevel.Province ||
                user.level === UserLevel.National) && (
                <li className="nav-item submenu">
                  <a
                    className={`nav-link ${
                      selectedTab === 5 ? "show active" : ""
                    }`}
                    id="pills-labkesmas-tab"
                    data-toggle="pill"
                    href="#pills-labkesmas"
                    role="tab"
                    aria-controls="pills-labkesmas"
                    aria-selected={selectedTab === 5}
                    onClick={() => {
                      const provId = user.province_id?.split("|")[0];
                      const distId = user.district_id?.split("|")[0];
                      this.switchTab(
                        5,
                        {
                          year: moment().format("YYYY"),
                          province_id: province_id || provId || "",
                          district_id: district_id || distId || "",
                          page: 1,
                          limit: 10,
                          searchValue: null,
                          searchBy: null,
                          data: [],
                        },
                        () => this.getAllData("Labkesmas")
                      );
                    }}
                  >
                    Labkesmas
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="tab-content mt-1 mb-3" id="pills-tabContent">
          {/* Tab Fasyankes */}
          <div
            className={`tab-pane fade ${
              selectedTab === 1 ? "show active" : ""
            }`}
            id="pills-fasyankes"
            role="tabpanel"
            aria-labelledby="pills-fasyankes-tab"
          >
            <Fragment>
              <div className="row">
                <div className="col">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      gap: "10px",
                      alignItems: "flex-end",
                      padding: "16px",
                      borderRadius: "10px",
                      backgroundColor: "#fbfafa",
                      border: "1px solid #ecedf0",
                      marginTop: "8px",
                      marginBottom: "24px",
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <InputDateTime
                        label="Tahun"
                        name="year"
                        dateFormat="YYYY"
                        onChange={(e) =>
                          this.handleInputChange({
                            preventDefault: () => {},
                            target: {
                              name: "year",
                              value: moment(e).format("YYYY"),
                            },
                          })
                        }
                        value={year}
                        isInline={true}
                        hasError={year_error}
                        errorMessage="Tahun wajib dipilih"
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <InputSelect
                        label="Provinsi"
                        name="province_id"
                        placeholder="Pilih"
                        data={this.mapper(provincies)}
                        onChange={(opt) => {
                          const val = opt ? opt.value : "";
                          this.handleInputChange({
                            preventDefault: () => {},
                            target: { name: "province_id", value: val },
                          });
                          this.setTabState({ district_id: "" });
                          this.getDistricts(val);
                        }}
                        value={
                          this.mapper(provincies).find(
                            (item) => item.value === province_id
                          ) || null
                        }
                        disabled={user.level === "District" ? true : false}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <InputSelect
                        label="Kabupaten"
                        name="district_id"
                        placeholder="Pilih"
                        data={this.mapper(districts)}
                        onChange={(opt) => {
                          const val = opt ? opt.value : "";
                          this.handleInputChange({
                            preventDefault: () => {},
                            target: { name: "district_id", value: val },
                          });
                        }}
                        value={
                          this.mapper(districts).find(
                            (item) => item.value === district_id
                          ) || null
                        }
                        disabled={user.level === "District" ? true : false}
                      />
                    </div>
                    <div>
                      <Button onClick={this.onFilter} isPrimary>
                        Terapkan
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-8" style={{ padding: "10px" }}>
                  <button
                    className="btn btn-teal font-weight-bold"
                    onClick={() => changeMode(PageMode.add, "Fasyankes", selectedTab)}
                  >
                    <PlusCircle className="mr-2" />
                    Tambah Data
                  </button>
                </div>
                <div className="col-sm-4">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control bg-light"
                      placeholder="Cari nama..."
                      onChange={this.onSearch}
                    />
                  </div>
                </div>
              </div>
            </Fragment>
          </div>
          {/* Tab District */}
          {(user.level === UserLevel.Province ||
            user.level === UserLevel.National) && (
            <div
              className={`tab-pane fade ${
                selectedTab === 2 ? "show active" : ""
              }`}
              id="pills-kab"
              role="tabpanel"
              aria-labelledby="pills-kab-tab"
            >
              <Fragment>
                <div className="row">
                  <div className="col">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                        alignItems: "flex-end",
                        padding: "16px",
                        borderRadius: "10px",
                        backgroundColor: "#fbfafa",
                        border: "1px solid #ecedf0",
                        marginTop: "8px",
                        marginBottom: "24px",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <InputDateTime
                          label="Tahun"
                          name="year"
                          dateFormat="YYYY"
                          onChange={(e) =>
                            this.handleInputChange({
                              preventDefault: () => {},
                              target: {
                                name: "year",
                                value: moment(e).format("YYYY"),
                              },
                            })
                          }
                          value={year}
                          isInline={true}
                          hasError={year_error}
                          errorMessage="Tahun wajib dipilih"
                        />
                      </div>

                      <div style={{ flex: 1 }}>
                        <InputSelect
                          label="Provinsi"
                          name="province_id"
                          placeholder="Pilih"
                          data={this.mapper(provincies)}
                          onChange={(opt) => {
                            const val = opt ? opt.value : "";
                            this.handleInputChange({
                              preventDefault: () => {},
                              target: { name: "province_id", value: val },
                            });
                          }}
                          value={
                            this.mapper(provincies).find(
                              (item) => item.value === province_id
                            ) || null
                          }
                          disabled={user.level === "District" ? true : false}
                        />
                      </div>

                      <div>
                        <Button onClick={this.onFilter} isPrimary>
                          Terapkan
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-8" style={{ padding: "10px" }}>
                    <button
                      className="btn btn-teal font-weight-bold"
                      onClick={() => changeMode(PageMode.add, "District", selectedTab)}
                    >
                      <PlusCircle className="mr-2" />
                      Tambah Data
                    </button>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control bg-light"
                        placeholder="Cari nama..."
                        onChange={this.onSearch}
                      />
                    </div>
                  </div>
                </div>
              </Fragment>
            </div>
          )}
          {/* Tab Province */}
          {user.level === UserLevel.National && (
            <>
              <div
                className={`tab-pane fade ${
                  selectedTab === 3 ? "show active" : ""
                }`}
                id="pills-prov"
                role="tabpanel"
                aria-labelledby="pills-prov-tab"
              >
                <Fragment>
                  <div className="row">
                    <div className="col">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "10px",
                          alignItems: "flex-end",
                          padding: "16px",
                          borderRadius: "10px",
                          backgroundColor: "#fbfafa",
                          border: "1px solid #ecedf0",
                          marginTop: "8px",
                          marginBottom: "24px",
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <InputDateTime
                            label="Tahun"
                            name="year"
                            dateFormat="YYYY"
                            onChange={(e) =>
                              this.handleInputChange({
                                preventDefault: () => {},
                                target: {
                                  name: "year",
                                  value: moment(e).format("YYYY"),
                                },
                              })
                            }
                            value={year}
                            isInline={true}
                            hasError={year_error}
                            errorMessage="Tahun wajib dipilih"
                          />
                        </div>
                        <div>
                          <Button onClick={this.onFilter} isPrimary>
                            Terapkan
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-8" style={{ padding: "10px" }}>
                      <button
                        className="btn btn-teal font-weight-bold"
                        onClick={() => changeMode(PageMode.add, "Province", selectedTab)}
                      >
                        <PlusCircle className="mr-2" />
                        Tambah Data
                      </button>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control bg-light"
                          placeholder="Cari nama..."
                          onChange={this.onSearch}
                        />
                      </div>
                    </div>
                  </div>
                </Fragment>
              </div>
              {/* bkk */}
              <div
                className={`tab-pane fade ${
                  selectedTab === 4 ? "show active" : ""
                }`}
                id="pills-bkk"
                role="tabpanel"
                aria-labelledby="pills-bkk-tab"
              >
                <Fragment>
                  <div className="row">
                    <div className="col">
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          gap: "10px",
                          alignItems: "flex-end",
                          padding: "16px",
                          borderRadius: "10px",
                          backgroundColor: "#fbfafa",
                          border: "1px solid #ecedf0",
                          marginTop: "8px",
                          marginBottom: "24px",
                        }}
                      >
                        <div style={{ flex: 1 }}>
                          <InputDateTime
                            label="Tahun"
                            name="year"
                            dateFormat="YYYY"
                            onChange={(e) =>
                              this.handleInputChange({
                                preventDefault: () => {},
                                target: {
                                  name: "year",
                                  value: moment(e).format("YYYY"),
                                },
                              })
                            }
                            value={year}
                            isInline={true}
                            hasError={year_error}
                            errorMessage="Tahun wajib dipilih"
                          />
                        </div>
                        <div>
                          <Button onClick={this.onFilter} isPrimary>
                            Terapkan
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-8" style={{ padding: "10px" }}>
                      <button
                        className="btn btn-teal font-weight-bold"
                        onClick={() => changeMode(PageMode.add, "BKK", selectedTab)}
                      >
                        <PlusCircle className="mr-2" />
                        Tambah Data
                      </button>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control bg-light"
                          placeholder="Cari nama..."
                          onChange={this.onSearch}
                        />
                      </div>
                    </div>
                  </div>
                </Fragment>
              </div>
            </>
          )}
          {/* Tab Labkesmas */}
          {(user.level === UserLevel.Province ||
            user.level === UserLevel.National) && (
            <div
              className={`tab-pane fade ${
                selectedTab === 5 ? "show active" : ""
              }`}
              id="pills-labkesmas"
              role="tabpanel"
              aria-labelledby="pills-labkesmas-tab"
            >
              <Fragment>
                <div className="row">
                  <div className="col">
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "10px",
                        alignItems: "flex-end",
                        padding: "16px",
                        borderRadius: "10px",
                        backgroundColor: "#fbfafa",
                        border: "1px solid #ecedf0",
                        marginTop: "8px",
                        marginBottom: "24px",
                      }}
                    >
                      <div style={{ flex: 1 }}>
                        <InputDateTime
                          label="Tahun"
                          name="year"
                          dateFormat="YYYY"
                          onChange={(e) =>
                            this.handleInputChange({
                              preventDefault: () => {},
                              target: {
                                name: "year",
                                value: moment(e).format("YYYY"),
                              },
                            })
                          }
                          value={year}
                          isInline={true}
                          hasError={year_error}
                          errorMessage="Tahun wajib dipilih"
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <InputSelect
                          label="Provinsi"
                          name="province_id"
                          placeholder="Pilih"
                          data={this.mapper(provincies)}
                          onChange={(opt) => {
                            const val = opt ? opt.value : "";
                            this.handleInputChange({
                              preventDefault: () => {},
                              target: { name: "province_id", value: val },
                            });
                            this.setTabState({ district_id: "" });
                            this.getDistricts(val);
                          }}
                          value={
                            this.mapper(provincies).find(
                              (item) => item.value === province_id
                            ) || null
                          }
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <InputSelect
                          label="Kabupaten"
                          name="district_id"
                          placeholder="Pilih"
                          data={this.mapper(districts)}
                          onChange={(opt) => {
                            const val = opt ? opt.value : "";
                            this.handleInputChange({
                              preventDefault: () => {},
                              target: { name: "district_id", value: val },
                            });
                          }}
                          value={
                            this.mapper(districts).find(
                              (item) => item.value === district_id
                            ) || null
                          }
                        />
                      </div>
                      <div>
                        <Button onClick={this.onFilter} isPrimary>
                          Terapkan
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-8" style={{ padding: "10px" }}>
                    <button
                      className="btn btn-teal font-weight-bold"
                      onClick={() => changeMode(PageMode.add, "Labkesmas", selectedTab)}
                    >
                      <PlusCircle className="mr-2" />
                      Tambah Data
                    </button>
                  </div>
                  <div className="col-sm-4">
                    <div className="form-group">
                      <input
                        type="text"
                        className="form-control bg-light"
                        placeholder="Cari nama..."
                        onChange={this.onSearch}
                      />
                    </div>
                  </div>
                </div>
              </Fragment>
            </div>
          )}
        </div>

        <TableComponent
          loading={loading}
          data={tableData}
          headers={headers}
          cols={cols}
          btnEdit={{ onClick: onEdit }}
          btnRemove={{ onClick: this.onRemove }}
          currentPage={data?.currentPage}
          total={data?.total}
          limit={data?.limit}
          nextPage={data?.nextPage}
          previousPage={data?.previousPag}
          onPageChange={this.onPageChange}
          withoutActionBtn={user.level === "District" ? true : false}
        />
      </div>
    );
  }
}
